import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/pages/Login.vue'
import Register from '@/pages/Register.vue'
import AppLayout from '@/components/Layouts/AppLayout.vue'
import Dashboard from '@/pages/Dashboard.vue'

function sessionUser() {
  const cookies = new URLSearchParams(document.cookie.split('; ').join('&'))
  const user = cookies.get('user_id')
  return user === 'Guest' ? null : user
}

const router = createRouter({
  history: createWebHistory('/retiora'),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { guestOnly: true },
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: { guestOnly: true },
    },
    {
      path: '/',
      component: AppLayout,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: 'getting-started',
          name: 'getting-started',
          component: () => import('@/pages/GettingStarted.vue'),
        },

        {
          path: 'learn',
          name: 'learn',
          meta: { sidebarGroup: 'learn' },
          component: () => import('@/pages/Learn.vue'),
        },
        {
          path: 'learn/create',
          name: 'create-learning',
          meta: { sidebarGroup: 'learn' },
          component: () => import('@/pages/learn/CreateLearning.vue'),
        },
        {
          path: 'learn/content/:contentId/edit',
          name: 'edit-learning',
          meta: { sidebarGroup: 'learn' },
          component: () => import('@/pages/learn/EditLearning.vue'),
        },
        {
          path: 'learn/:learningId',
          name: 'learning-detail',
          meta: { sidebarGroup: 'learn' },
          component: () => import('@/pages/learn/LearningDetail.vue'),
        },
        {
          path: 'learn/:learningId/item/:itemId',
          name: 'knowledge-item',
          meta: { sidebarGroup: 'learn' },
          component: () => import('@/pages/learn/KnowledgeItem.vue'),
        },
        {
          path: 'learn/:learningId/recall',
          name: 'active-recall',
          meta: { sidebarGroup: 'learn' },
          component: () => import('@/pages/learn/ActiveRecall.vue'),
        },

        {
          path: 'review',
          name: 'review',
          component: () => import('@/pages/Review.vue'),
        },

        {
          path: 'library',
          name: 'library',
          meta: { sidebarGroup: 'library' },
          component: () => import('@/pages/Library.vue'),
        },
        {
          path: 'library/:contentId',
          name: 'library-content-detail',
          meta: { sidebarGroup: 'library' },
          component: () => import('@/pages/LibraryContentDetail.vue'),
        },

        {
          path: 'progress',
          name: 'progress',
          component: () => import('@/pages/Progress.vue'),
        },

        {
          path: 'settings',
          name: 'settings',
          component: () => import('@/pages/Settings.vue'),
        },
        {
          path: 'notifications',
          name: 'notifications',
          component: () => import('@/pages/Notifications.vue'),
        },
      ],
    },
  ],
})

router.beforeEach((to) => {
  const isLoggedIn = Boolean(sessionUser())

  if (to.meta.requiresAuth && !isLoggedIn) {
    return { name: 'login' }
  }

  if (to.meta.guestOnly && isLoggedIn) {
    return { name: 'dashboard' }
  }
})

export default router
